import React, { PropsWithChildren } from 'react';
import { Text, TextProps } from '@landr/maestro';
import { css } from '@landr/styled-system/css';
import { SystemStyleObject } from '@landr/styled-system/types';

interface TextDecorationUnderlineProps extends TextProps {
    styles?: SystemStyleObject;
}

const TextDecorationUnderline: React.FC<
    PropsWithChildren<TextDecorationUnderlineProps>
> = ({ children, styles, ...props }) => (
    <Text
        userSelect="none"
        className={css({
            '& a': {
                textDecoration: 'underline',
                _hover: {
                    textDecoration: 'none',
                },
            },
            ...styles,
        })}
        {...props}
    >
        {children}
    </Text>
);

export default TextDecorationUnderline;
